module.exports = __webpack_public_path__ + "static/WindingWorlds1-faced795baa3c146719a3e0fb67b6b28.webp";